import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/style/tailwind.css';
import './assets/font-awesome/css/fontawesome.min.css'
import './assets/font-awesome/css/duotone.min.css'
import './assets/font-awesome/css/light.min.css'

Vue.config.productionTip = false


new Vue({

  router,
  store,
  render: h => h(App)
}).$mount('#app')
